export const PHONE_NUMBER_REGEX = /^\+?\d{7,20}$/;
